import type { LocaleData } from '@/types';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { supportedLanguages } from './languages';
import { resources } from './resources';

const browserLocale = typeof window !== 'undefined' ? (window as Window & { locale?: LocaleData }).locale : undefined;

if (typeof window !== 'undefined') {
    // Locale resolution belongs to the server. Storage may be unavailable in privacy mode.
    try {
        window.localStorage.removeItem('i18nextLng');
    } catch {
        // The server-provided locale still works without browser storage.
    }

    void i18n.use(initReactI18next).init({
        resources,
        supportedLngs: [...supportedLanguages],
        lng: browserLocale?.current || 'pt',
        fallbackLng: browserLocale?.fallback || 'en',
        debug: false,
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        },
    });
}

export default i18n;
